import { Checkbox, styled, TableRow } from "@mui/material";
import { RiskLevel } from "@wallet-manager/node-types/dist/src/postgres/const";
import { ReactNode } from "react";
import { SendingAddressMap } from "src/views/AssetManagement/BatchContractSweep/contexts/PreviewContext";
import { isSweepAmountSelected } from "../../helpers/selectionHelpers";
import { TABLE_COLUMNS, TableColumnId } from "../../constants/tableColumns";
import OverflowTooltipText from "src/components/OverflowTooltipText";
import StyledTableCell from "../../components/StyledTableCell";

const StyledTableRow = styled(TableRow)({
  background: "#eaeaea",
  ":hover": {
    background: "#e1e1e1",
  },
  "&:last-of-type": { border: "0px" },
});

type TableBodyRowProps = {
  serialNumber: number;
  sendingAddress: string;
  senderInfo: SendingAddressMap extends Map<string, infer T> ? T : never;
  spenderAddress: string;
  t: (key: string) => string;
  toDisplayAmountWithCurrency: (amount: string | number) => string;
  onToggleAddress: (sendingAddress: string, isChecked: boolean) => void;
};

function TableBodyRow({
  serialNumber,
  sendingAddress,
  senderInfo,
  spenderAddress,
  t,
  toDisplayAmountWithCurrency,
  onToggleAddress,
}: TableBodyRowProps) {
  const {
    sweepableAmount,
    sweepAmount,
    walletVersion,
    riskLevel,
    noRiskLevelCount,
    isPendingQueue,
  } = senderInfo;

  const cellNodeByColumnId: Record<TableColumnId, ReactNode> = {
    serial_number: <OverflowTooltipText text={serialNumber} />,
    wallet_version: walletVersion,
    sending_address: <OverflowTooltipText text={sendingAddress} copyable />,
    // spender_address: <OverflowTooltipText text={spenderAddress} copyable />,
    risk_level: <OverflowTooltipText text={t(RiskLevel[riskLevel])} />,
    pending_queue: (
      <OverflowTooltipText text={isPendingQueue ? t("yes") : t("no")} />
    ),
    no_risk_level_data_count: <OverflowTooltipText text={noRiskLevelCount} />,
    select_all: (
      <Checkbox
        disabled={isPendingQueue}
        checked={isSweepAmountSelected(sweepAmount, isPendingQueue)}
        onChange={(event) => {
          onToggleAddress(sendingAddress, event.target.checked);
        }}
      />
    ),
    sweep_amount: (
      <OverflowTooltipText
        text={toDisplayAmountWithCurrency(sweepableAmount)}
      />
    ),
    //  {node: (<NumericFormat
    //     onValueChange={({ value }) => {
    //       setSendingAddressesMap((prev) =>
    //         new Map(prev).set(sendingAddress, {
    //           walletVersion,
    //           sweepableAmount,
    //           sweepAmount: value,
    //         }),
    //       );
    //     }}
    //     customInput={MpTextField}
    //     thousandSeparator
    //     value={sweepAmount}
    //     onBlur={() => {
    //       if (sweepAmount) {
    //         return;
    //       }

    //       setSendingAddressesMap((prev) =>
    //         new Map(prev).set(sendingAddress, {
    //           walletVersion,
    //           sweepableAmount,
    //           sweepAmount: "0",
    //         }),
    //       );
    //     }}
    //   />)}
  };

  return (
    <StyledTableRow key={sendingAddress}>
      {TABLE_COLUMNS.map((column) => (
        <StyledTableCell
          key={column.id}
          align="center"
          sx={{ minWidth: column.minWidth }}
        >
          {cellNodeByColumnId[column.id]}
        </StyledTableCell>
      ))}
    </StyledTableRow>
  );
}

export default TableBodyRow;
